import axios from 'axios';
import { decryptOpenSSL } from './decryp';
import {
  updateEnvironments,
  updateSecure,
} from 'store/useAtomOutsideComponent';
import { API_REST_URL_AUTH_SECURE, refreshEnvVars } from 'config/variables';

export const getEnvironmentsConfigApp = async ({
  token,
}: {
  token: string;
}) => {
  if (!token) throw new Error('Token not found');

  try {
    const response = await axios.get(API_REST_URL_AUTH_SECURE, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = response.headers['x-custom-header'];
    const basekey = response.headers['x-session-header'];
    const configApp = response.headers['x-config-app'];
    const decryp = decryptOpenSSL(configApp as string, `${data}${basekey}`);
    updateEnvironments(decryp);

    updateSecure(data);

    // Recalcula las constantes de config/variables que dependen del store de
    // secrets, para que ningún módulo importado después lea valores vacíos.
    refreshEnvVars();
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('getEnvironmentsConfigApp failed:', {
        status: error.response?.status,
        data: error.response?.data,
      });
    } else {
      console.error('getEnvironmentsConfigApp failed:', error);
    }
    throw new Error(
      'Error trying to get the configuration of the app environment',
    );
  }
};
